import { useCallback } from 'react';
import { FormRadioGroupInputComponent } from 'src/features/generalForms/builder/types/RadioGroupInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';

export const FormRadioGroupInput: FormRadioGroupInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const renderValue = useCallback(
    (v: string) =>
      props.options
        ?.filter((opt) => opt.key === v)
        .map((opt) => opt.value)
        .join(', ') ?? '',
    [props.options],
  );

  return <AnswerPreviewRow<string> value={value} renderValue={renderValue} {...props} />;
};
